import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {

  transform(value: string, args?: any): string {
    if (value) {
      // first, strip all non digits from the phone number
      const justDigits = value.replace(/\D/g, '');
      // then try to make it match a full number
      const match = justDigits.match(/^\d{10}$/);
      if (match && match.length > 0) {
        // then format it a standard way
        return `(${justDigits.substr(0, 3)}) ${justDigits.substr(3, 3)}-${justDigits.substr(6)}`;
      }
    }

    return value; // can't transform it
  }
}
